
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CommunicationGroupApi } from '../api/communicationgroup.api';
import { switchMap, map } from 'rxjs/operators';

import { CommunicationGroupData, CommunicationGroup } from '../../../interfaces/masters/communicationgroup' ;
@Injectable()
export class CommunicationGroupService extends CommunicationGroupData {

    constructor(private api: CommunicationGroupApi) {
      super();
    }
  
  
    list(url: string): Observable<CommunicationGroup[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<CommunicationGroup>{
        return this.api.getById(url);
    }
  
    create(url: string, data:CommunicationGroup): Observable<CommunicationGroup[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:CommunicationGroup): Observable<CommunicationGroup> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  